import { render, staticRenderFns } from "./TheoryPracticeWorkshopsLessonsAttachmentsManagement.vue?vue&type=template&id=54a33d40&scoped=true&"
import script from "./TheoryPracticeWorkshopsLessonsAttachmentsManagement.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeWorkshopsLessonsAttachmentsManagement.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeWorkshopsLessonsAttachmentsManagement.vue?vue&type=style&index=0&id=54a33d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a33d40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VDataTable,VSpacer,VTextField,VTooltip})
